import { Injectable, ErrorHandler } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { GenericService } from '../services/generic.service';

@Injectable()
export class AggErrorHandler implements ErrorHandler {
    public genericService = GenericService;

    constructor(private _genericService: GenericService) {}

    handleError(error) {
      if (error instanceof HttpErrorResponse) {
          console.log(error);
      } else {
          this._genericService.AggDataArrObs.complete();
          this._genericService.AggDataArrObs.subscribe(
            (val) => {},
            (err) => {},
            ()    => { //this._genericService.updateSpinner(); 
            }
          );
      }     
    }
} 